import { Component } from '@angular/core';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { AgencyService } from '../_Services/agency.service';
import { Router } from '@angular/router'; 

@Component({
  templateUrl: 'addagent.component.html'
})
export class AddagentComponent {

	model: any = {};
    responseStatus:Object= [];
    status:boolean ;
    error = ''; 
	constructor(private router: Router, private agencyService: AgencyService) { }

	onSubmit() {
		console.log(this.model);
		this.agencyService.addAgency(this.model).subscribe(result => {
            if (result.status === true) {
                this.router.navigate(['/agencies/addagentpic/' + result.agency_id]);
            } else {
                this.error = 'Username or password is incorrect'; 
            }
        }); 
	}

}



// WEBPACK FOOTER //
// ./src/app/agencies/addagent.component.ts